﻿import { ValgStateActionTypes, ValgState, UPDATE_VALG } from './Types';

export const initialState: ValgState = {
    aVarighet: undefined,
    bBetale: undefined,
    cSkolepenger: undefined,
    cSkolepengerBelop: undefined,
    visBetPlan: false,
};

export function valgReducer(state: ValgState = initialState, action: ValgStateActionTypes): ValgState {
    const newState = getNewState();
    return newState;

    function getNewState(): ValgState {
        switch (action.type) {
            case UPDATE_VALG: {
                if (action.payload.aVarighet) {
                    return {
                        ...initialState,
                        ...action.payload,
                    };
                } else {
                    return {
                        ...state,
                        ...action.payload,
                    };
                }
            }
            default:
                return state;
        }
    }
}
